//#region types
import { TranslationKeys } from "translations";
import { COST_FORWARDING_DESCRIPTION_MAX_LENGTH } from "./costForwardingMarkingModel";
//#endregion
import * as Yup from "yup";

const customerField = Yup.object({
  id: Yup.number(),
  value: Yup.string(),
}).default(undefined);

/** Spread into the receipt and supplier invoice to-do schemas and the receipt create schema. */
export const costForwardingValidationFields = {
  costForwardingAvailable: Yup.boolean(),
  costForwardingState: Yup.number(),
  costForwardingCustomer: customerField,
  costForwardingDescription: Yup.string().max(
    COST_FORWARDING_DESCRIPTION_MAX_LENGTH,
    TranslationKeys.Validations.ValueTooLong
  ),
};

// Clearing the customer un-marks a document, which is a mistake on one that is not marked yet.
export const costForwardingMarkDialogValidationFields = {
  ...costForwardingValidationFields,
  costForwardingCustomer: customerField.required(TranslationKeys.Validations.Required),
};
